import React, { useState, useEffect } from 'react';
import imgHoja from "../../../assets/images/hoja_1.svg";
import imgHoja2 from "../../../assets/images/hoja_2.svg";
import imglogoMobile from "../../../assets/images/logo-club-morado.png";
import imglogo from "../../../assets/images/logo_blanco.png";
import Button from '../../../shared/components/atoms/button/button';
import Toast from '../../../shared/components/atoms/toast/toast';
import GenericModal from '../../../shared/components/organisms/generic-modal/generic-modal';
import useHomeLinkMode from "../../../shared/hooks/useHomeLinkMode";
import ForcePassChange from '../../molecules/force-pass-change/force-pass-change';
import useInfoTransversal from '../../../shared/hooks/useInfoTransversal'
import useHaveClubPeque from '../../../shared/hooks/useHaveClubPeque'
import { localStorage } from '../../../shared/utils/storage';
import Login from '../../molecules/login/login';
import './authentication-content.scss';

const AuthenticationContent = ({ contentInfo }) => {


    const { homeLink } = useHomeLinkMode();
    const [activeToast, setActiveToast] = useState(false);
    const [activeModal, setActiveModal] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const { countryInfoTransversal } = useInfoTransversal()
    const { haveClubPeque } = useHaveClubPeque()
    const isEC = process.env.LOCALE === ("es-EC")
    //TO DO volver a la pagina anterior falta revisar bn
    const backPage = () => {
        window.history.back();
    }

    const openModal = (password, tokenData) => {
        setActiveModal(true)
        setModalContent(
            <ForcePassChange
                password={password}
                tokenData={tokenData}
                setModalContent={setModalContent}
                setActiveToast={setActiveToast}
            />)
    }

    useEffect(() => {
        if (localStorage.getItem("TOKEN_INFO")) {
            location.href = homeLink
        }
    }, [])

    if (!activeModal) {
        return (
            <div className="f-o-authentication">
                <div className="f-o-authentication__modal">
                    <img className="f-o-authentication__modal-img1" src={imgHoja} alt="" />
                    <img className="f-o-authentication__modal-img2" src={imgHoja2} alt="" />
                    <img className="f-o-authentication__modal-logo" src={countryInfoTransversal[0].logo.file.url} alt="" />
                    <div className="f-o-authentication__modal-close" onClick={backPage}>
                        X
                    </div>
                    <div className="f-o-authentication__modal-left">
                        <div className="f-o-authentication__modal-left-content">
                            <div className="f-o-authentication__modal-left-info">
                                <img className="f-o-authentication__modal-logo-mobile" src={countryInfoTransversal[0].logo.file.url} alt="" />
                                {haveClubPeque ?
                                    <div>
                                        <h2>¿Quieres unirte al Club Pequeñín?</h2>
                                        <p className="f-o-authentication__modal-left-info-copy">
                                            Podrás tener a todos los beneficios del club, promociones de la marca y mucho más.
                                        </p>
                                    </div>
                                    :
                                    isEC ?
                                    <div>
                                        <h2>¿Quieres ser parte de Pequeñín?</h2>
                                        <p className="f-o-authentication__modal-left-info-copy">
                                            Registrándote tendrás acceso a beneficios, promociones de la marca y mucho más.
                                        </p>
                                    </div>
                                    :
                                    <div>
                                        <h2>¿Quieres unirte a la comunidad Pequeñin?</h2>
                                        <p className="f-o-authentication__modal-left-info-copy">
                                            Podrás recibir noticias exclusivas de la marca, promociones, tips y mucho más.
                                        </p>
                                    </div>
                                    }
                                <Button className="f-a-button__secondary-purple f-a-button__medium f-o-authentication__modal-left-info-button"
                                    copy="Regístrate aquí"
                                    onclick={() => { location.href = homeLink + "registro/" }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="f-o-authentication__modal-right">
                        <div className="f-o-authentication__modal-right-content">
                            <div className="f-o-authentication__modal-right-info">
                                <Login setActiveToast={setActiveToast} openModal={openModal} />
                            </div>
                        </div>
                    </div>
                </div>


                <Toast
                    message={activeToast.messageToast ? activeToast.messageToast : null}
                    check={activeToast.checkToast ? activeToast.checkToast : null}
                    activeToast={activeToast}
                    setActiveToast={setActiveToast}
                />
            </div>
        )
    } else if (activeModal) {

        return (
            <div className="f-o-authentication__jump-modal">
                <GenericModal>
                    {modalContent}
                </ GenericModal>
            </div>

        )
    }
}

export default AuthenticationContent